import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { HeaderTitleProps } from '../../../../types/headerTitleProps'
import { PlanName } from '../PlanName'

export const IndividualTitle = (props: HeaderTitleProps) => {
  const { isIndividualSelected } = usePlansContext()

  return <PlanName isSelected={isIndividualSelected} {...props} />
}
